import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import Micro from '@gdcyy/micro-js-sdk'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: Micro.baseRouter,
  routes
})

export default router
